import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const filterReplacementScheduleConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default filterReplacementScheduleConfig;
